module.exports = __webpack_public_path__ + "5c027c5adc5e8a39c65f940b91606984.MP3";